import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import StandardInput     from 'app/components/common/standard-input';
import StateSelect       from 'app/components/common/state-select';



const isValidZip = (zip) => {
  if (!(zip || '').trim()) return false;
  if (zip.length === 5) return zip.replace(/[^\d]/g, '').length === 5;
  if (zip.length === 10) {
    const [p1, p2] = zip.split('-');
    if (p1.length !== 5) return false;
    if (p2.length !== 4) return false;
    return true;
  }
  return false;
};



class AddressInput2 extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      hasTouched: false,
      line1: null,
      line2: null,
      city: null,
      stateCode: null,
      postalCode: null,
    };

    this.onChangeLine1 = this.onChangeLine1.bind(this);
    this.onChangeLine2 = this.onChangeLine2.bind(this);
    this.onChangeCity = this.onChangeCity.bind(this);
    this.onChangeState = this.onChangeState.bind(this);
    this.onChangePostalCode = this.onChangePostalCode.bind(this);
  }

  componentDidMount() {
  }

  get address() {
    const obj = {};
    ['line1', 'line2', 'city', 'stateCode', 'postalCode'].forEach((attr) => {
      obj[attr] = this.state[attr];
      if (obj[attr] == null) {
        obj[attr] = this.props.address?.[attr] || null;
      }
    });
    return obj;
  }

  get saveAddress() {
    const address = this.address;
    const obj = {};
    ['line1', 'line2', 'city', 'stateCode', 'postalCode'].forEach((attr) => {
      obj[attr] = (address[attr] || '').trim();
    });
    return obj;
  }

  get isValid() {
    const address = this.saveAddress;
    const missingAttr = ['line1', 'city', 'stateCode', 'postalCode'].find(attr => !address[attr]);
    if (missingAttr) return false;
    if (!isValidZip(address.postalCode)) return false;
    return true;
  }

  onChangeLine1(event) {
    const line1 = event.target.value;
    this.setStateAndEmit({line1});
  }
  onChangeLine2(event) {
    const line2 = event.target.value;
    this.setStateAndEmit({line2});
  }
  onChangeCity(event) {
    const city = event.target.value;
    this.setStateAndEmit({city});
  }
  onChangeState(stateCode) {
    this.setStateAndEmit({stateCode: stateCode || ''});
  }
  onChangePostalCode(event) {
    const postalCode = event.target.value.replace(/[^\d-]/g, '').substring(0, 10);
    this.setStateAndEmit({postalCode});
  }

  setStateAndEmit(newState) {
    this.setState({...newState, hasTouched: true}, () => {
      const address = this.isValid ? this.saveAddress : null;
      this.props.onChange(address);
    });
  }

  render() {
    const {className} = this.props;
    const address = this.address;

    return (
      <div className={`addr-input ${className}`}>
        <StandardInput className="addr-input-line1" name="line1" label="Address" onChange={this.onChangeLine1} value={address.line1 || ''} elevateFocus />
        <StandardInput className="addr-input-line2" name="line2" label="Apartment, suite, etc. (optional)" onChange={this.onChangeLine2} value={address.line2 || ''} elevateFocus />
        <div className="addr-input-row">
          <StandardInput className="addr-input-city" name="city" label="City" onChange={this.onChangeCity} value={address.city || ''} elevateFocus />
          <StateSelect className="addr-input-state" value={address.stateCode || null} onSelect={this.onChangeState} allowClear elevateFocus />
          <StandardInput className="addr-input-zip" name="postalCode" label="Zip Code" onChange={this.onChangePostalCode} value={address.postalCode || ''} elevateFocus />
        </div>
      </div>
    );
  }

}

AddressInput2.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  address: PropTypes.shape({
    line1: PropTypes.string.isRequired,
    line2: PropTypes.string,
    city: PropTypes.string.isRequired,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    countryCode: PropTypes.string,
  }),
};

AddressInput2.defaultProps = {
  className: '',
};

export default AddressInput2;
